import React, { useEffect, useState } from "react";
import InvoicePage from "../../../../../entities/DashboardPage/AccountingModule/Invoice/InvoiceHome";
import LoaderHelper from "../../../../../utils/Loader/LoaderHelper";
import AuthService from "../../../../../api/AuthService";
import { useAlert } from "../../../../../context/AlertContext";
import RecurringTemplatePage from "../../../../../entities/DashboardPage/AccountingModule/Invoice/InvoiceHome/RecurringTemplate";
import { useLocation } from "react-router-dom";
// eslint-disable-next-line import/default

const RecurringTemplate = () => {
  const [recurringTemplateDetail, setRecurringTemplateDetail] = useState([]);
  const [childInvoices, setChildInvoices] = useState([]);
  const { state } = useLocation();

  useEffect(() => {
    getRecurringTemplateDetails()
  }, []);

  const getRecurringTemplateDetails = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getRecurringInvoiceTemplateDetail(state.item?._id);
      if (result?.success) {
        setRecurringTemplateDetail(result?.data);
        setChildInvoices(result?.data?.childInvoices)
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  return (
    <RecurringTemplatePage
      recurringTemplateDetail={recurringTemplateDetail}
      childInvoices={childInvoices}
    />
  );
};

export default RecurringTemplate;
